export const STOCK_MOVEMENT_TYPE_OPERATION = 'operation'
export const STOCK_MOVEMENT_TYPE_RESET = 'reset'
export const STOCK_NOT_MANAGED = 'notManaged'
export const STOCK_MANAGED = 'managed'
